<section>
  <h2>Event People</h2>
  <p-messages key="eventPersonMsg" [closable]="true"></p-messages>
  <ng-container *ngIf="peopleService.personTypes$ | async as personTypes; else loading">
    <p-table #peopleTable [value]="people" [dataKey]="'PeopleStagingID' ||'PeopleID'" [paginator]="true" [alwaysShowPaginator]="false" [rows]="rows" [autoLayout]="true" responsiveLayout="scroll" styleClass="mb-3">
      <ng-template pTemplate="caption">
        <div class="p-2 fw-bold text-center">People Selection</div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th scope="col" pSortableColumn="LastName">
            Last Name
            <p-sortIcon field="LastName" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
          </th>
          <th scope="col" pSortableColumn="FirstName">
            First Name
            <p-sortIcon field="FirstName" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
          </th>
          <th scope="col">
            Birth Date
          </th>
          <th scope="col">
            SSN
          </th>
          <th scope="col">Type</th>
          <th scope="col"><span class="visually-hidden">Delete row</span></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td colspan="6">
            No person found.
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
        <tr>
          <td><button type="button" (click)="viewPersonDetails(rowData.PersonStagingID, rowData.PersonID, 'associated')" class="btn-link btn px-0" tabindex="0" aria-label="Person {{rowData.LastName}} details">{{rowData.LastName}}</button></td>
          <td>{{rowData.FirstName}}</td>
          <td>{{rowData.DateOfBirth  | date:"MM/dd/yyyy" }}</td>
          <td>{{rowData.SSN | ssnFormat}}</td>
          <td>
            <label id="PersonType{{rowIndex}}Label" class="form-label required-field-before w-100 ps-4">
              <span class="visually-hidden ">Select the person type(s).</span>
              <p-multiSelect #pt inputId="PersonType{{rowIndex}}"
                             dataKey="PersonTypeID"
                             required
                             [(ngModel)]="rowData['ENESS_XREF_EventsPeopleTypes']"
                             [options]="personTypes"
                             optionLabel="PersonTypeName"
                             placeholder="Select person type(s)"
                             styleClass="form-select form-select-sm"
                             [tabindex]="0"
                             [filter]="false"
                             [showHeader]="false"
                             (onChange)="onPersonTypeChange($event, rowIndex)"
                             appendTo="body"
                             [showToggleAll]="false"
                             ariaFilterLabel="Filter the list of person types"
                             ariaLabelledBy="PersonType{{rowIndex}}Label"
                             selectedItemsLabel="{0} types selected">
              </p-multiSelect>
            </label>
            <div class="cross-validation-feedback" *ngIf="!rowData['ENESS_XREF_EventsPeopleTypes'] || !rowData['ENESS_XREF_EventsPeopleTypes'].length">
              Please select person type(s).
            </div>
          </td>
          <td class="text-center">
            <button type="button" (click)="removePerson(rowIndex)" class="btn btn-sm btn-danger" title="Remove Person"><i class="fas fa-times" aria-hidden="true"></i><span class="visually-hidden">Remove Person</span></button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </ng-container>
  <div class="card my-3">
    <div class="card-body">
      <div class="card-title"><h3 class="h4 mb-3">Find an existing person</h3></div>
      <form [formGroup]="findPersonFormGroup" class="row row-cols-md-auto g-lg-3 g-md-2 align-items-start mb-3">
        <div class="col-12">
          <div class="row">
            <label for="SelectFilterType" class="required-field col-auto mb-2">Filter by:</label>
            <div class="col-auto mb-2">
              <select #filterTypeSelect class="form-select form-select-sm" id="SelectFilterType" formControlName="FilterID" (change)="onSelectFilterType(filterTypeSelect.value)" required aria-required="true">
                <option value="{{ null }}">Select person filter type</option>
                <option *ngFor="let filter of peopleService.personFilterTypes$ | async" value="{{filter.FilterColumnName}}">{{ filter.FilterDisplayValue }}</option>
              </select>
              <div class="invalid-feedback">Please select a filter type.</div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <ng-container *ngIf="['Name', 'DateOfBirth', 'SSN', 'PhoneNumber'].indexOf(findPersonFormGroup.get('FilterID').value) == -1">
            <label for="personFilterInput" class="visually-hidden">Filter text:</label>
            <input id="personFilterInput" formControlName="FilterInput" type="text" class="form-control form-control-sm mb-2" />
          </ng-container>
          <ng-container *ngIf="findPersonFormGroup.get('FilterID').value === 'Name'">
            <div class="row">
              <label for="FirstName" class="col-auto mb-2">First name:</label>
              <div class="col-auto mb-2"><input id="FirstName" type="text" formControlName="FilterFirstNameInput" class="form-control form-control-sm" /></div>
            </div>
            <div class="row">
              <label for="LastName" class="col-auto mb-2">Last name:</label>
              <div class="col-auto mb-2"><input id="LastName" type="text" formControlName="FilterLastNameInput" class="form-control form-control-sm" /></div>
            </div>
          </ng-container>
          <ng-container *ngIf="findPersonFormGroup.get('FilterID').value === 'DateOfBirth'">
            <label for="FilterDate" class="visually-hidden">Filter date</label>
            <p-calendar inputId="FilterDate" formControlName="FilterDate" [showIcon]="true" [monthNavigator]="true" [yearNavigator]="true" inputStyleClass="form-control form-control-sm mb-2" [showOnFocus]="false" [maxDate]="maxDateRule" appendTo="body"></p-calendar>
          </ng-container>
          <ng-container *ngIf="findPersonFormGroup.get('FilterID').value === 'SSN'">
            <label for="FilterSSN" class="visually-hidden">Filter SSN</label>
            <p-inputMask inputId="FilterSSN" formControlName="FilterSSN" mask="999-99-9999" styleClass="form-control form-control-sm mb-2"></p-inputMask>
          </ng-container>
          <ng-container *ngIf="findPersonFormGroup.get('FilterID').value === 'PhoneNumber'">
            <label for="FilterPhoneNumber" class="visually-hidden">Filter Phone Number</label>
            <p-inputMask inputId="PhoneNumber" formControlName="FilterPhoneNumber" mask="(999) 999-9999" styleClass="form-control form-control-sm mb-2" [ariaRequired]="true" [maxlength]="80" [autoClear]="false"></p-inputMask>
          </ng-container>
          <div class="cross-validation-feedback" *ngIf="!findPersonFormGroup.pristine && !!findPersonFormGroup.get('FilterID').value && !findPersonFormGroup.valid">
            Please enter a filter value.
          </div>
        </div>
        <div class="col-12">
          <button type="button" class="btn btn-sm btn-success mb-2" (click)="onSearchPerson()" [disabled]="findPersonFormGroup?.errors"><i class="fas fa-search" aria-hidden="true"></i> Find</button>
        </div>
      </form>
      <ng-container *ngIf="eventDataSvc.peopleResults$ | async as findPeopleResults">
        <p-messages key="findPeopleMsg" [closable]="true"></p-messages>
        <p-table #dt [value]="findPeopleResults" [columns]="peopleSearchResultTableCols" selectionMode="multiple" [(selection)]="selectedPeople" [paginator]="true" [alwaysShowPaginator]="false" [rows]="rows" [autoLayout]="true" responsiveLayout="scroll" styleClass="mb-3">
          <ng-template pTemplate="caption">
            <div class="p-2 fw-bold text-center">Find Existing People Result</div>
          </ng-template>
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" scope="col" [pSortableColumn]="col.field">
                {{col.header}}
                <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData>
            <tr [pSelectableRow]="rowData">
              <th scope="col" [innerHTML]="getFBIFileNumbers(rowData.ENESS_XREF_PeopleFBIFileNumbers) | joinArray:';'  | lineBreakTransform:';'"></th>
              <td [innerHTML]="getStateIDNumbers(rowData.ENESS_XREF_PeopleStateIDNumbers) | joinArray:';' | lineBreakTransform:';'"></td>
              <td><button type="button" (click)="viewPersonDetails('', rowData.PersonID, 'find')" tabindex="0" class="btn btn-link" aria-label="{{'view the person '+rowData.LastName+' details'}}">{{rowData.LastName}}</button></td>
              <td>{{rowData.FirstName}}</td>
              <td>{{rowData.DateOfBirth | date:"MM/dd/yyyy" }}</td>
              <td>{{rowData.SSN | ssnFormat}}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length">
                No people found.
              </td>
            </tr>
          </ng-template>
        </p-table>
        <button type="button" class="btn btn-success btn-sm mb-2 me-2" [disabled]="selectedPeople?.length === 0" (click)="associateSelectedPeople()">Add selected people to event</button>
        <button type="button" class="btn btn-success btn-sm mb-2" (click)="onAddPersonClick()">Add a new person</button>
      </ng-container>
      <ng-template #loading>
        <div class="m-3">Loading event people...</div>
      </ng-template>
    </div>
  </div>
</section>
<aside *ngIf="displaySidebar">
  <p-sidebar [(visible)]="displaySidebar" (onShow)="onShowSidebar()" (onHide)="onHideSidebar()" position="right" [blockScroll]="true" styleClass="p-sidebar-lg" [showCloseIcon]="false">
    <ng-container *ngIf="openViewPersonDetailForm">
      <ng-container *ngIf="eventDataSvc.personDetails$ | async as personDTO; else loadingPerson">
        <ness-person-detail [personDTO]="personDTO" [isEventPersonForm]="true" [hasDeletePermission]="false" [suppressEdit]="false" (onEditPerson)="onEditPerson($event)" (showPersonAddressDetail)="viewAddressDetails($event)"></ness-person-detail>
        <button type="button" (click)="onViewPersonDetailsClose()" class="btn btn-active m-3">Close</button>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="openAddEditPersonForm">
      <ng-container *ngIf="eventDataSvc.personDetails$ | async as personDTO; else loadingPerson">
        <ness-person-form [titleText]="addEditPersonTitleText" [mode]="personFormMode" [isEventAddPersonSearch]="isEventAddPersonSearch" [isPersonStaging]="isPersonStaging" [isEventPerson]="true" [addPeopleAddress]="fromPeopleLocationForm" [eventAddEditPerson]="personDTO" (onPersonSaved)="onPersonSaved($event)" (closeForm)="onEditPersonClose($event)">
        </ness-person-form>
      </ng-container>
    </ng-container>
    <ng-template #loadingPerson><div class="m-3">Loading person...</div></ng-template>
    <ng-container *ngIf="openViewPersonAddressDetails">
      <ng-container *ngIf="personAddress; else loadingAddress">
        <ness-location-detail *ngIf="showLocationView" [addressDTO]="personAddress" [hasDeletePermission]="false" [hasEditPermission]="hasPermissionToEditAddress" [personAddressType]="personAddressType" [isFromPersonDetails]="true" (editLocationLocationClicked)="editLocation($event)"></ness-location-detail>
        <button type="button" (click)="onClickCloseButton()" class="btn btn-active m-3">Close</button>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="openViewPersonAddressDetailForm">
      <ng-container *ngIf="personAddress; else loadingAddress">
        <ness-location-form *ngIf="showEditLocationView" [titleText]="'Edit location'" [isEventLocationForm]="false" [isEditForm]="true" [locationFormData]="personAddress" (associateLocation)="onLocationFormClose($event)" (closeForm)="onClickCloseButton()" (locationSaved)="onLocationFormClose($event)"></ness-location-form>
      </ng-container>
    </ng-container>
    <ng-template #loadingAddress>
      <p-messages #viewPersonDetailMsg key="viewAddressDetailsMsg" [closable]="true"></p-messages>
      <div class="m-3">Loading location...</div>
    </ng-template>
    <ng-container *ngIf="openNewLocationForm">
      <ness-location-form [searchLocation]="searchAddress$ | async" [titleText]="addEditLocationTitleText" [isEditForm]="false" [isEventLocationForm]="true" [isPersonAddressForm]="false" [associationButtonLabel]="associationButtonLabel" (associateLocation)="onNewLocationAdded($event)" (closeForm)="onNewLocationClose()"></ness-location-form>
    </ng-container>
    <ng-container *ngIf="openFindExistingLocationForm">
      <ness-find-existing-location [associationButtonLabel]="existingLocationAssociationButtonLabel" (associateLocation)="onAddExistingLocations($event)" (closeForm)="onAddExistingLocationsClose()"></ness-find-existing-location>
    </ng-container>
  </p-sidebar>
</aside>
